"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = void 0;
var _definitions = require("@ppay/definitions");
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactResponsive = require("react-responsive");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Table = require("./Table");
var _data = require("./data");
var _Card = require("./Card");
var _ui = require("../../ui");
var _utils = require("../../../utils");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledHighlightedSegment = (0, _styledComponents.default)(_ui.HighlightedSegment)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 16px 20px;\n"])));
var CardTitle = (0, _styledComponents.default)(_ui.CardTitle)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 5px;\n"])));
var SpinnerWrapper = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  min-height: 300px !important;\n"])));
var Component = function Component(_ref) {
  var loading = _ref.loading,
    totalBalance = _ref.totalBalance,
    balances = _ref.balances,
    _onDepositClick = _ref.onDepositClick,
    _onSendClick = _ref.onSendClick,
    onHistoryClick = _ref.onHistoryClick;
  var isMobile = (0, _reactResponsive.useMediaQuery)({
    maxWidth: _utils.breakpoints.lg
  });
  var _useTranslation = (0, _reactI18next.useTranslation)('libWallets'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Card, null, /*#__PURE__*/_react.default.createElement(_ui.CardHeader, {
    className: 'd-flex align-items-start justify-content-between'
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(CardTitle, null, t('title')), /*#__PURE__*/_react.default.createElement(_ui.CardSubtitle, null, t('subtitle'))), !isMobile && /*#__PURE__*/_react.default.createElement(_data.DataTotalBalance, {
    value: totalBalance,
    ticker: _definitions.Ticker.USD
  })), loading ? /*#__PURE__*/_react.default.createElement(SpinnerWrapper, {
    className: "d-flex justify-content-center align-items-center py-3"
  }, /*#__PURE__*/_react.default.createElement(_ui.Spinner, {
    color: "primary"
  })) : isMobile ? /*#__PURE__*/_react.default.createElement(_ui.CardBody, {
    className: "pt-0"
  }, /*#__PURE__*/_react.default.createElement(StyledHighlightedSegment, null, /*#__PURE__*/_react.default.createElement(_data.DataTotalBalance, {
    className: "justify-content-center",
    value: totalBalance,
    ticker: _definitions.Ticker.USD,
    isMobile: true
  })), balances.map(function (b) {
    return /*#__PURE__*/_react.default.createElement(_Card.Card, {
      key: b.ticker,
      balance: b,
      onDepositClick: function onDepositClick() {
        return _onDepositClick(b.ticker);
      },
      onSendClick: function onSendClick() {
        return _onSendClick(b.ticker);
      },
      onHistoryClick: onHistoryClick
    });
  })) : /*#__PURE__*/_react.default.createElement(_ui.CardBody, null, /*#__PURE__*/_react.default.createElement(_Table.Table, {
    balances: balances,
    onDepositClick: _onDepositClick,
    onSendClick: _onSendClick,
    onHistoryClick: onHistoryClick
  })));
};
exports.Component = Component;